import {
  ApiPaginationResponse,
  ApiResponse,
  CreateDepartmentRequest,
  CreateUserRequest,
  DepartmentResponse,
  Login,
  LoginRequest,
  RoleType,
  TabLogin,
  UpdateDepartmentRequest,
  UpdateUserRequest,
  UserFilterRequest,
  UserModel,
} from '@/types';
import { DepartmentModal } from '@/types/models/department.modal';
import http from '../01_axios';
import { API_LIST } from './url';

// User APIs
const getListUser = (
  filters: UserFilterRequest,
): Promise<ApiPaginationResponse<UserModel>> => {
  return http.post(API_LIST.LIST_USER, filters);
};

const getAllUser = (): Promise<ApiResponse<UserModel[]>> => {
  return http.get(API_LIST.GET_ALL);
};

const getUserById = (id: number): Promise<ApiResponse<UserModel>> => {
  return http.get(API_LIST.USER_DETAIL(id));
};
const paidLeaveNumber = (): Promise<ApiResponse<number>> => {
  return http.get(API_LIST.PAID_LEAVE_NUMBER);
};
const createUser = (
  data: CreateUserRequest,
): Promise<ApiResponse<UserModel>> => {
  const formData = new FormData();

  formData.append('username', data.username);
  formData.append('password', data.password);
  if (data.name) formData.append('name', data.name);
  if (data.leaveDate) formData.append('leaveDate', data.leaveDate);
  if (data.workingDate) formData.append('workingDate', data.workingDate);
  if (data.cccd) formData.append('cccd', data.cccd);
  if (data.agent) formData.append('agent', data.agent);
  if (data.phone) formData.append('phone', data.phone);
  if (data.email) formData.append('email', data.email);
  if (data.roleId) formData.append('roleId', data.roleId.toString());
  if (data.departmentId)
    formData.append('departmentId', data.departmentId.toString());
  if (data.paidLeaveNumber)
    formData.append('paidLeaveNumber', data.paidLeaveNumber.toString());

  if (data.file) {
    formData.append('file', data.file);
  }

  return http.post(API_LIST.CREATE_USER, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

const updateUser = (
  data: UpdateUserRequest,
): Promise<ApiResponse<UserModel>> => {
  const formData = new FormData();

  if (data.id) formData.append('id', data.id.toString());
  if (data.username) formData.append('username', data.username);
  if (data.name) formData.append('name', data.name);
  if (data.leaveDate) formData.append('leaveDate', data.leaveDate);
  if (data.workingDate) formData.append('workingDate', data.workingDate);
  if (data.cccd) formData.append('cccd', data.cccd);
  if (data.agent) formData.append('agent', data.agent);
  if (data.phone) formData.append('phone', data.phone);
  if (data.email) formData.append('email', data.email);
  if (data.active) formData.append('active', data.active ? 'true' : 'false');

  if (data.roleId) formData.append('roleId', data.roleId.toString());
  if (data.departmentId)
    formData.append('departmentId', data.departmentId.toString());
  if (data.paidLeaveNumber)
    formData.append('paidLeaveNumber', data.paidLeaveNumber.toString());

  if (data.file) {
    formData.append('file', data.file);
  }

  return http.post(API_LIST.UPDATE_USER, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

const deleteUser = (id: number): Promise<ApiResponse> => {
  return http.patch(API_LIST.DELETE_USER(id));
};

// Department APIs
const getDepartments = (
  textSearch?: string,
): Promise<ApiResponse<DepartmentResponse>> => {
  return http.post(API_LIST.LIST_DEPARTMENT, { textSearch });
};

const getDepartmentById = (
  id: number,
): Promise<ApiResponse<DepartmentModal>> => {
  return http.get(API_LIST.DEPARTMENT_DETAIL(id));
};

const createDepartment = (
  data: CreateDepartmentRequest,
): Promise<ApiResponse<DepartmentModal>> => {
  return http.post(API_LIST.CREATE_DEPARTMENT, data);
};

const updateDepartment = (
  data: UpdateDepartmentRequest,
): Promise<ApiResponse<DepartmentModal>> => {
  return http.put(API_LIST.UPDATE_DEPARTMENT, data);
};

const deleteDepartment = (id: number): Promise<ApiResponse> => {
  return http.patch(API_LIST.DELETE_DEPARTMENT(id));
};
const changeActive = (id: number): Promise<ApiResponse> => {
  return http.patch(API_LIST.CHANGE_ACTIVE(id));
};

const login = (body: LoginRequest): Promise<ApiResponse<Login>> => {
  return http.post(API_LIST.LOGIN, body);
};
const getListTab = (): Promise<ApiResponse<TabLogin[]>> => {
  return http.get(API_LIST.LIST_TAB);
};
const getRoleType = (): Promise<ApiResponse<Array<RoleType>>> => {
  return http.get(API_LIST.LIST_ROLE_TYPE);
};
export const userService = {
  getListUser,
  getUserById,
  createUser,
  updateUser,
  deleteUser,
  getDepartments,
  getDepartmentById,
  createDepartment,
  updateDepartment,
  deleteDepartment,
  login,
  getListTab,
  getRoleType,
  getAllUser,
  paidLeaveNumber,
  changeActive,
};
